import ErrorAlert from "@/utility/ErrorAlert";
import http from "../axios/http-common";

async function create(data) {
  const response = await http
    .postData("/identitas-bayi-baru-lahir", data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function update(id, data) {
  const response = await http
    .putData(`/identitas-bayi-baru-lahir/${id}`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function getByRegister(register_id: string | number) {
  const response = await http
    .getData(`/register/${register_id}/identitas-bayi-baru-lahir`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function findByRegisterSilent(register: any) {
  const reg = register && typeof register === "object" ? register.no : register;
  if (!reg) return null;
  try {
    const res: any = await http.getData(`/register/${reg}/identitas-bayi-baru-lahir`);
    const body = res && res.data ? res.data : null;
    return body && body.status === 1 && body.data ? body.data : null;
  } catch (e) {
    return null;
  }
}

async function find(id: number) {
  const response = await http
    .getData(`/identitas-bayi-baru-lahir/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function destroy(id: number) {
  const response = await http
    .deleteData(`/identitas-bayi-baru-lahir/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

function print(id) {
  window.open(
    `${http.getAPI()}/identitas-bayi-baru-lahir/${id}/pdf`,
    "_blank"
  );
}

export default {
  create,
  update,
  getByRegister,
  findByRegisterSilent,
  find,
  destroy,
  print
};
